// Login lives on the parent platform, not in this app - it redirects back
// here with ?token= (see App.js), which is what actually logs the user in.
export const FORESYTS_LOGIN_URL = "https://www.foresyts.ai/"

export const NON_EMPTY_REGEX = /^(?!\s*$).+/

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export const NON_EMPTY_SINGLE_NUMBER = /\b[0-9]\b/

export const NON_EMPTY_NUMBER = /^\d+$/

export const NON_CHARACTER = /^[0-9.\-+]+$/

//Validate symbol except space
export const VALIDATE_SYMBOL = /^[^<>*|/\\~#{}()[\],$^%&+=_@'?.!"]+$/g

export const STATUS = {
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  ERROR: "ERROR",
  INVALID_PAYLOAD: "INVALID_PAYLOAD",
  AUTHENTICATION_FAILED: "AUTHENTICATION_FAILED",
  AUTHENTICATION_SUCCESSFUL: "AUTHENTICATION_SUCCESSFUL",
  VALID_SESSION: "VALID_SESSION",
  INVALID_CODE: "INVALID_CODE",
  RECORD_NOT_FOUND: "RECORD_NOT_FOUND",
  INVALID_SESSION: "INVALID_SESSION",
  PASSWORD_UPDATED: "PASSWORD_UPDATED",
  SOMETHING_WENT_WRONG: "SOMETHING_WENT_WRONG",
  REASON: "SEND_REASON",
}
